/**
 * 模块：系统事件报警
 * 作者：haikuo.zhang
 * 时间：2021-09-14
 */

import * as commonConst from '../common/constants';
import * as systemEventConst from './constants';
import * as systemEventApis from '../../services/apis/systemEvent';

export default {
    //查询实例系统事件
    [systemEventConst.DescribeInstanceSystemEvents](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, systemEventApis.DescribeInstanceSystemEvents);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(systemEventConst.DescribeInstanceSystemEvents, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //修改实例维护属性
    [systemEventConst.ModifyInstanceMaintenanceAttribute](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, systemEventApis.ModifyInstanceMaintenanceAttribute);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(systemEventConst.ModifyInstanceMaintenanceAttribute, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
};

